import { CroBridge, CroBridge__factory } from '@config/abi/types';
import { BigNumberish, ContractTransaction, Signer } from 'ethers';

export const getCroBridgeContract = (
  contractAddress: string,
  signer: Signer
) => {
  return CroBridge__factory.connect(contractAddress, signer);
};

export const cronosToCryptoOrgTransfer = async (
  destinationAddress: string,
  amount: BigNumberish,
  croBridge: CroBridge
): Promise<ContractTransaction> => {
  return await croBridge.send_cro_to_crypto_org(destinationAddress, {
    value: amount,
  });
};
